import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { licenciamentosModuleName } from "../shared/data.service";
import { Licenciamento } from "../shared/licenciamento.model";
import { LicenciamentoNavigationService } from "../shared/licenciamento-navigation.service";
import { LicenciamentoApiService } from "../shared/licenciamento-api.service";
import { UtilService } from "../../../shared/services/util.service";
import {configuracaoModuleName, editRoute, newRoute} from "../../../shared/services/data.service";
import { LicenciamentosService } from "../shared/licenciamento.service";
import {Estado} from "../../../estruturas/enderecos/estados/shared/estado.model";
import {months} from "../../../abastecimentos/abastecimento-bens/shared/data.service";
import {EstadoApiService} from "../../../estruturas/enderecos/estados/shared/estado-api.service";
import {DespachoService} from "../../shared/despacho.service";
import {obrigacoesModuleName} from "../../obrigacoes/shared/data.service";
import {ProjetoService} from "../../../projeto/shared/projeto.service";

@Component({
    template: require('./licenciamento-form.component.html'),
    styles: [require('./licenciamento-form.component.css')]
})
export class LicenciamentoFormComponent implements OnInit {
    licenciamentosModule: any = licenciamentosModuleName;
    module: any = obrigacoesModuleName;
    configuracaoModule: any = configuracaoModuleName;
    formObject: any = new Licenciamento();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;

    monthsList: any[] = [];
    mesObject: any = {};
    estadosList: Estado[] = [];
    loadingEstados: boolean = true;
    estadoObject: Estado = new Estado();

    form: FormGroup;
    estado = new FormControl('', Validators.required);
    mes = new FormControl('', Validators.required);
    finalPlaca = new FormControl('', Validators.required);
    ativo = new FormControl('');

    private project: any;

    constructor(
        private _route: ActivatedRoute,
        private _licenciamentoNavigationService: LicenciamentoNavigationService,
        private _licenciamentoApiService: LicenciamentoApiService,
        private _licenciamentosService: LicenciamentosService,
        private _utilService: UtilService,
        private _estadoApiService: EstadoApiService,
        private _despachoService: DespachoService,
        private _projetoService: ProjetoService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            finalPlaca: this.finalPlaca,
            estado: this.estado,
            mes: this.mes
        });
    }

    ngOnInit() {
        this.project = this._projetoService.getSessionStorage();
        this.monthsList = this._utilService.cloneObject(months);
        this.mesObject = this.monthsList[0];
        this.getEstados();

        let id = +this._route.snapshot.params['id'];
        if (id) {
            this.setEditNormal(id);
        } else {
            this.setNewNormal();
        }

        this.setActionTitle(id);
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.goToList();
    }

    clickGoToConfig() {
        this._despachoService.goToSettingObrigacoes();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:Licenciamento = this._utilService.cloneObject(this.formObject);

            if (this.estadoObject.id) {
                object.estadoId = this.estadoObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.mesObject.Value) {
                object.mes = this.mesObject.Key;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.formObject.id) {
                this.onEditLicenciamento(object);
            } else {
                this.onAddLicenciamento(object);
            }
        }
    }

    private onAddLicenciamento(object: Licenciamento) {
        this._licenciamentoApiService.onPost(object, this.onDone);
    }

    private onEditLicenciamento(object: Licenciamento) {
        this._licenciamentoApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.goToList();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();

            } else {
                this._utilService.swalMessageWarningCustom('Nenhum licenciamento encontrado com este id.');
                this.goToList();
            }
        }.bind(this));

        this._licenciamentoApiService.onGetById(id, onDone);
    }

    private getEstados() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.estadosList = Response;
                this.setEstado();
            }
            this.loadingEstados = false;
        }.bind(this));

        this._estadoApiService.onGetAll(onDone);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setModelToForm() {
        if (this.formObject.estado) {
            this.estadoObject = this.formObject.estado;
            delete this.formObject['estado'];
            this.setEstado();
        }

        if (this.formObject.mes){
            this.mesObject = this.monthsList[this.formObject.mes];
        }
    }

    private setEstado() {
        let x: number, lenX: number,
            t: any = this.estadoObject.id;
        if (!t && this.estadosList.length) {
            if (this.project) {
                t = this.project.estadoId;
            } else {
                t = this.estadosList[11].id;
            }
        }

        for (x = 0, lenX = this.estadosList.length; x < lenX; x++) {
            if (this.estadosList[x].id === t) {
                this.estadoObject = this.estadosList[x];
                break;
            }
        }
    }

    private goToList() {
        this._licenciamentoNavigationService.goToList();
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/licenciamento-form/licenciamento-form.component.ts
 **/